import { render, staticRenderFns } from "./TitleSynopsis.vue?vue&type=template&id=956b2d16&scoped=true"
import script from "./TitleSynopsis.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleSynopsis.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleSynopsis.vue?vue&type=style&index=0&id=956b2d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956b2d16",
  null
  
)

export default component.exports